import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/color/hue.module.css";

export default {
  "container": "hue-module__container_950xGW__010",
  "hue": "hue-module__hue_950xGW__010",
  "hueHorizontal": "hue-module__hueHorizontal_950xGW__010",
  "hueVertical": "hue-module__hueVertical_950xGW__010",
  "pointerDefault": "hue-module__pointerDefault_950xGW__010",
  "pointerVertical": "hue-module__pointerVertical_950xGW__010",
  "slider": "hue-module__slider_950xGW__010"
};
      